export const USAGE_DASHBOARD_STYLES = `
/* ── Usage Dashboard Container ── */
.usage-dashboard-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  background: var(--bg-primary, white);
  border-radius: 8px;
}

.usage-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  gap: 16px;
}

.spinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--border-color, #e5e7eb);
  border-top-color: var(--blue-500, #3b82f6);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.loading-text {
  font-size: 14px;
  color: var(--text-muted, #6b7280);
}

.usage-error {
  padding: 16px;
  background: var(--red-50, #fef2f2);
  border: 1px solid var(--red-200, #fecaca);
  border-radius: 6px;
  color: var(--red-700, #b91c1c);
  font-size: 14px;
}

/* ── Header ── */
.usage-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border-color, #e5e7eb);
}

.usage-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary, #1f2937);
}

.usage-date-range {
  font-size: 13px;
  color: var(--text-muted, #6b7280);
}

/* ── Main content grid ── */
.usage-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.usage-grid {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.usage-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 16px;
}

.usage-row.full-width {
  grid-template-columns: 1fr;
}

/* ── Usage sections ── */
.usage-section {
  padding: 16px;
  background: var(--bg-secondary, #f9fafb);
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.chart-title {
  margin: 0 0 12px;
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary, #1f2937);
}

.chart-empty {
  padding: 20px;
  text-align: center;
  color: var(--text-muted, #6b7280);
  font-size: 14px;
}

/* ── Pie chart ── */
.usage-pie-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pie-chart {
  max-width: 200px;
  margin: 0 auto;
}

.pie-legend {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pie-legend-item {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 6px;
  border-radius: 4px;
  font-size: 13px;
}

.pie-legend-color {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  flex-shrink: 0;
}

.pie-legend-label {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.pie-legend-name {
  color: var(--text-primary, #1f2937);
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pie-legend-duration {
  color: var(--text-muted, #6b7280);
  font-weight: 500;
  flex-shrink: 0;
}

/* ── Weekly bar chart ── */
.usage-bar-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.weekly-bars {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
  padding: 12px 0;
}

.bar-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.bar-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted, #6b7280);
  text-transform: uppercase;
}

.bar-track {
  width: 100%;
  height: 100px;
  background: var(--bg-primary, white);
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 2px;
  display: flex;
  flex-direction: column-reverse;
  position: relative;
  overflow: hidden;
}

.bar-fill {
  background: var(--blue-500, #3b82f6);
  width: 100%;
  transition: height 0.3s ease;
}

.bar-value {
  font-size: 12px;
  font-weight: 500;
  color: var(--text-primary, #1f2937);
  margin-top: 4px;
}

.weekly-stats {
  display: flex;
  gap: 16px;
  padding-top: 12px;
  border-top: 1px solid var(--border-color, #e5e7eb);
}

.stat-item {
  flex: 1;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
}

.stat-label {
  color: var(--text-muted, #6b7280);
  font-weight: 500;
}

.stat-value {
  color: var(--text-primary, #1f2937);
  font-weight: 600;
}

/* ── Block events ── */
.block-events-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.block-summary {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.block-stat-card {
  padding: 12px;
  background: var(--bg-primary, white);
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 4px;
  text-align: center;
}

.block-stat-label {
  font-size: 12px;
  color: var(--text-muted, #6b7280);
  margin-bottom: 4px;
}

.block-stat-value {
  font-size: 18px;
  font-weight: 700;
  color: var(--blue-600, #2563eb);
}

.block-subsection-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary, #1f2937);
  padding: 8px 0 4px;
}

.top-blocked-apps {
  padding-top: 12px;
  border-top: 1px solid var(--border-color, #e5e7eb);
}

.blocked-app-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  font-size: 13px;
  border-bottom: 1px solid var(--bg-secondary, #f3f4f6);
}

.blocked-app-row:last-child {
  border-bottom: none;
}

.app-name {
  color: var(--text-primary, #1f2937);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}

.block-count {
  color: var(--red-600, #dc2626);
  font-weight: 600;
  margin-left: 8px;
  flex-shrink: 0;
}

/* ── Trends ── */
.trends-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.trends-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.trend-item {
  padding: 8px;
  background: var(--bg-primary, white);
  border-left: 3px solid var(--gray-300, #d1d5db);
  border-radius: 2px;
  font-size: 12px;
}

.trend-item.trend-up {
  border-left-color: var(--red-500, #ef4444);
}

.trend-item.trend-down {
  border-left-color: var(--green-500, #10b981);
}

.trend-item.trend-stable {
  border-left-color: var(--gray-400, #9ca3af);
}

.trend-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

.trend-app-name {
  font-weight: 600;
  color: var(--text-primary, #1f2937);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}

.trend-arrow {
  font-weight: 700;
  font-size: 14px;
  flex-shrink: 0;
}

.trend-item.trend-up .trend-arrow {
  color: var(--red-500, #ef4444);
}

.trend-item.trend-down .trend-arrow {
  color: var(--green-500, #10b981);
}

.trend-stats {
  display: flex;
  justify-content: space-between;
  gap: 4px;
  color: var(--text-muted, #6b7280);
  font-size: 11px;
}

.trend-prev,
.trend-current {
  flex: 1;
}

.trend-change {
  font-weight: 600;
  text-align: right;
  flex-shrink: 0;
  min-width: 35px;
}

.trend-item.trend-up .trend-change {
  color: var(--red-600, #dc2626);
}

.trend-item.trend-down .trend-change {
  color: var(--green-600, #059669);
}

/* ── Daily limit prediction ── */
.limit-prediction-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.limit-card {
  padding: 16px;
  background: var(--green-50, #f0fdf4);
  border: 1px solid var(--green-200, #bbf7d0);
  border-radius: 6px;
}

.limit-card.will-exceed {
  background: var(--orange-50, #fffbeb);
  border-color: var(--orange-200, #fed7aa);
}

.limit-progress {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 12px;
}

.progress-bar {
  flex: 1;
  height: 24px;
  background: var(--gray-200, #e5e7eb);
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: var(--green-500, #10b981);
  transition: width 0.3s ease;
}

.limit-card.will-exceed .progress-fill {
  background: var(--orange-500, #f59e0b);
}

.progress-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary, #1f2937);
  min-width: 35px;
  text-align: right;
}

.limit-stats {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.limit-stat-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
}

.limit-stat-row.warning {
  color: var(--orange-700, #92400e);
}

.limit-stat-label {
  color: var(--text-muted, #6b7280);
  font-weight: 500;
}

.limit-stat-value {
  color: var(--text-primary, #1f2937);
  font-weight: 600;
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .usage-row {
    grid-template-columns: 1fr;
  }

  .block-summary {
    grid-template-columns: repeat(2, 1fr);
  }

  .weekly-bars {
    grid-template-columns: repeat(7, 1fr);
    gap: 6px;
  }

  .bar-track {
    height: 80px;
  }
}
`;
